export default __webpack_public_path__ + "static/media/img-merchant-wallets-4.6695a92f.png";